var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"path-widget"},_vm._l((_vm.menus_data),function(item,index){return _c('div',{key:index,staticClass:"path-item",class:{
      start: index == 0,
      middle: index > 0 && _vm.menus_data.length - 1 > index,
      end: _vm.menus_data.length - 1 == index,
      active: item.active,
    },on:{"click":function($event){return _vm.selectPath(item)}}},[_c('span',[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"right-carret"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }